
import * as actionTypes from './actionTypes';
import { tempSave } from './index';

export const authorizeUser = (accessValues) => {
  return {
    type: actionTypes.AUTHORIZE_USER,
    values: accessValues
  }
}

export const logout = () => {
  return {
    type: actionTypes.LOGOUT
  }
}

export const checkIfTokenExpired = (detail, dispatch) => {
  if (detail === "Access token expired") {
    dispatch(tempSave("Access token expired"));
    dispatch(logout());
    return true;
  }
  return false;
}